import { render } from "./PrintGuidePage.vue?vue&type=template&id=21a5114e&scoped=true&ts=true"
import script from "./PrintGuidePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrintGuidePage.vue?vue&type=script&setup=true&lang=ts"

import "./PrintGuidePage.vue?vue&type=style&index=0&id=21a5114e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a5114e"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/print-page/PrintGuidePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21a5114e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21a5114e', __exports__)) {
    api.reload('21a5114e', __exports__)
  }
  
  module.hot.accept("./PrintGuidePage.vue?vue&type=template&id=21a5114e&scoped=true&ts=true", () => {
    api.rerender('21a5114e', render)
  })

}


export default __exports__